import { PostContext } from 'context/PostContext';
import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react';

export const PostInteractionGetterContext = createContext<{
  commentCount: number;
}>({
  commentCount: 0,
});

export const PostInteractionSetterContext = createContext<{
  setCommentCount: Dispatch<SetStateAction<number>>;
}>({
  setCommentCount: () => {},
});

const PostInteractionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const postInfo = useContext(PostContext);

  const [commentCount, setCommentCount] = useState(postInfo.commentCount);

  return (
    <PostInteractionSetterContext.Provider
      value={{
        setCommentCount,
      }}
    >
      <PostInteractionGetterContext.Provider
        value={{
          commentCount,
        }}
      >
        {children}
      </PostInteractionGetterContext.Provider>
    </PostInteractionSetterContext.Provider>
  );
};

export default PostInteractionProvider;
